<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/143/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            成华区为吸引集聚更多的优秀技术人才来成华创新就业，按照《成都市成华区关于“建设全国创新人才高地特色区加快人才集聚发展的若干政策”认定类项目申报实施办法》，对产业急需紧缺技术人才提供津贴支持。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            支持新引进（培育）年龄不超过45周岁的博士（博士后）、高级专业技术职称人才、高级技师。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/143/title2.png" alt="" />
          <div class="content">
            <div class="des">
              <div>
                （一）新进入我区博士后科研工作站和创新实践基地的博士后人员，在站期间给予10万元人才津贴，从新进的次月起满1年、2年，按5万元/人/年的标准发放。
              </div>
            </div>
            <div class="des">
              <div>
                （二）对区内企业新引进的博士后青年科技人才及正高级专业技术职称人才给予10万元人才津贴，从引进的次月起满1年、2年、3年，按每人每年3万元、3万元、4万元的标准发放；博士、副高级专业技术职称、特级技师人才给予5万元人才津贴，从引进的次月起满1年、2年、3年，按每人每年1万元、2万元、2万元的标准发放；高级技师给予2万元人才津贴，从引进的次月起满1年、2年、3年，按每人每年0.5万、0.5万、1万元的标准发放。
              </div>
            </div>
            <div class="des">
              <div>
                （三）对区内企业新培育获评的工程系列、自然科学系列正高级专业技术职称人才，且被所在单位聘任相应专业技术职务的，给予6000元人才津贴；工程系列、自然科学系列副高级专业技术职称人才、特级技师，且被所在单位聘任相应专业技术技能职务的，给予3000元人才津贴；高级技师且被所在单位聘任相应技能职务的，给予2000元人才津贴。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title3.png" alt="" />
          <div
            class="content"
            style="background-color: #fff;"
          >
          每年集中受理上一年度引进（培育）人员的申请，符合条件的个人，通过企业向属地街道或产业功能区申请，经属地初审、部门复审、公示、审定等程序，确定认定名单。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/137/title4.png" alt="" />
          <div
            class="content"
            style="background-color: #fff; font-weight: bolder"
          >
            按照每年度通知时间确定。
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/137/title5.png" alt="" />
          <div class="content">
            <div class="number" >
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-84310100">028-84310100</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              成都市成华区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
                  <img class="info" src="../assets/imgs/133/code.png" />
              </div> -->
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.2rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 4.86rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
